import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggleTargets() {
    this.element.classList.toggle("is-open")
  }
}
